import { render, staticRenderFns } from "./ChangeMailModal.vue?vue&type=template&id=23f8bc3d&scoped=true&"
import script from "./ChangeMailModal.vue?vue&type=script&lang=js&"
export * from "./ChangeMailModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeMailModal.vue?vue&type=style&index=0&id=23f8bc3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f8bc3d",
  null
  
)

export default component.exports